import {process, State} from "@progress/kendo-data-query"
import {Button} from "@progress/kendo-react-buttons"
import {Grid, GridCellProps, GridColumn, GridDataStateChangeEvent, GridToolbar} from "@progress/kendo-react-grid"
import {MDBCard, MDBCardBody, MDBCardTitle, MDBCol} from "mdbreact"
import {useState} from "react"
import {initDealer, setModalToggle, setSelectedDealer} from "../../containers/RegionAndDealers/RADSlice"
import {getTestStationsById} from "../../containers/TestStation/testStationSlice"
import {RootState} from "../../rootReducer"
import {columnProps} from "../../shared/ActiveGridFilter"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import {hasPermission} from "../Shared/permissionChecker"

const DealerGrid = () => {
    const dispatch = useAppDispatch()

    const initialState: State = {skip: 0, take: 100}

    const dealers = useAppSelector((state: RootState) => state.containers.regions.dealers)

    const isDealerLoading = useAppSelector((state: RootState) => state.containers.regions.isDealerLoading)
    const selectedRegion = useAppSelector((state: RootState) => state.containers.regions.selectedRegion)
    const regionSelected = useAppSelector((state: RootState) => state.containers.regions.regionSelected)
    const [dataState, setDataState] = useState(initialState)
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)

    const toggleDealerModel = (e: any, props: any) => {
        e.preventDefault()
        dispatch(setModalToggle(true))
        dispatch(setSelectedDealer(props.dataItem))
        dispatch(getTestStationsById())
    }
    const NameLinkCell = (props: any) => (
        <td className={props.dataItem.active ? "" : "text-black-50"} style={{left: "0px"}}>
            <a
                href=" "
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                onClick={event => toggleDealerModel(event, props)}
            >
                {props.dataItem.dealerName}
            </a>
        </td>
    )

    const CommomLinkCell = (props: GridCellProps) => (
        <td className={props.dataItem.active ? "" : "text-black-50"} title={props.dataItem[`${props.field}`]}>
            {props.dataItem[`${props.field}`]}
        </td>
    )

    return (
        <MDBCol md="8">
            <div className="position-relative">
                {isDealerLoading && <SpinnerGrid />}
                <MDBCard>
                    <MDBCardBody className="p-2">
                        <MDBCardTitle className="text-muted mb-0 pt-2 pb-2">
                            {selectedRegion ? `${selectedRegion} dealers` : "Dealers"}
                        </MDBCardTitle>

                        <Grid
                            style={{
                                height: "calc(100vh - 13.4rem)",
                            }}
                            data={dealers.length > 0 ? process(dealers, dataState) : []}
                            {...dataState}
                            dataItemKey={"dealerId"}
                            onDataStateChange={(e: GridDataStateChangeEvent) => setDataState(e.dataState)}
                        >
                            {hasPermission(["Dealers.Add"], assignedPermissions) && (
                                <GridToolbar>
                                    <Button
                                        type="submit"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        iconClass="fa fa-plus"
                                        title="Add dealer"
                                        disabled={regionSelected.regionId === 0}
                                        onClick={() => {
                                            dispatch(setModalToggle(true))
                                            dispatch(setSelectedDealer(initDealer()))
                                        }}
                                    >
                                        Add Dealer
                                    </Button>
                                </GridToolbar>
                            )}
                            <GridColumn
                                {...columnProps("dealerName", dataState)}
                                field="dealerName"
                                title="Dealer"
                                cell={props => <NameLinkCell {...props} />}
                            />
                            <GridColumn
                                {...columnProps("dealerNumber", dataState)}
                                field="dealerNumber"
                                title="Dealer Number"
                                editor="text"
                                cell={CommomLinkCell}
                            />
                            <GridColumn
                                {...columnProps("preparerId", dataState)}
                                field="preparerId"
                                title="Preparer Id"
                                editor="text"
                                cell={CommomLinkCell}
                            />
                            <GridColumn
                                {...columnProps("phoneNumber", dataState)}
                                field="phoneNumber"
                                title="Phone Number"
                                editor="text"
                                cell={CommomLinkCell}
                            />
                            <GridColumn
                                field="hasLocalATF"
                                cell={(props: any) => (
                                    <td className={props.dataItem.active ? "" : "text-black-50"}>
                                        {props.dataItem.hasLocalATF ? "YES" : ""}
                                    </td>
                                )}
                                title="Has Local ATF"
                                editor="boolean"
                            />
                        </Grid>
                    </MDBCardBody>
                </MDBCard>
            </div>
        </MDBCol>
    )
}

export default DealerGrid
